import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { first, forkJoin, from, interval, map, Observable, of, shareReplay, switchMap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DxSelectBoxTypes } from 'devextreme-angular/ui/select-box';
import { QualificationTargetTypeModel } from '../../models/settings/qualification-target-type.model';
import { LoadingService } from '../../services/loading.service';
import { GeneralSettingsService } from '../../services/general-settings.service';
import { PersonService } from '../../services/person.service';
import { TimeService } from '../../services/time.service';
import { TranslateService } from '@ngx-translate/core';
import { RoleService } from '../../services/role.service';
import { UnregisteredRoleModel } from '../../models/settings/unregistered-role.model';
import { UserService } from '../../services/user.service';
import { DxDataGridComponent, DxDropDownBoxComponent, DxFormComponent } from 'devextreme-angular';
import { TenantUpdateModel } from "../../models/tenants/tenant-update.model";
import { SettingTabsModel } from 'src/app/models/settings/setting-tabs.model';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { TenantSubscriptionModel } from 'src/app/models/tenants/tenant-subscription.model';
import { TenantSubscriptionUpdateModel } from 'src/app/models/tenants/tenant-subscription-update.model';
import { RawFileModel } from 'src/app/models/raw-file-model';
import { FileUtilService } from 'src/app/services/file-util.service';
import { TenantSubscriptionService } from 'src/app/services/tenants/tenant-subscription.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectOption } from 'src/app/models/select-option.model';
import { MarketSegmentModel } from 'src/app/models/settings/market-segment.model';
import validationEngine from 'devextreme/ui/validation_engine';
import { TenantModel } from 'src/app/models/tenants/tenant.model';
import { TenantTypeModel } from 'src/app/models/tenants/tenant-type.model';
import { RegistrationFieldConfigService } from 'src/app/services/registration-field-config.service';
import { RegistrationFieldConfigModel } from 'src/app/models/registration-field-configs/registration-field-config.model';
import { RegistrationFieldConfigComponent } from 'src/app/components/registration-field-config/registration-field-config.component';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { ROLE_NAMES } from 'src/app/constants/role.constants';
import { Clipboard } from '@angular/cdk/clipboard';
import { RoleModel } from 'src/app/models/person/role.model';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';
import { OrganisationUnitService } from 'src/app/services/organisation-unit.service';
import { TenantChannelModel } from 'src/app/models/tenants/tenant-channel.model';
import { IddEscalationThresholdsComponent } from './idd-escalation-thresholds/idd-escalation-thresholds.component';
import { FONT_SIZES } from 'src/app/constants/font-sizes';
import { FONT_FAMILIES } from 'src/app/constants/fonts';

@Component({
  selector: 'app-external-contacts-form',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
  standalone: false
})
export class GeneralSettingsComponent implements OnInit {
  @ViewChild('subscriptionForm')
  subscriptionForm!: DxFormComponent;

  @ViewChild('segmentForm', { static: false })
  segmentForm!: DxFormComponent;

  @ViewChild('qualificationForm', { static: false })
  qualificationForm!: DxFormComponent;
  
  @ViewChild('registrationFieldConfigs')
  registrationFieldConfigsForm!: RegistrationFieldConfigComponent;

  @ViewChild('iddEscalationThresholds')
  iddEscalationThresholdsComponent!: IddEscalationThresholdsComponent;

  @ViewChild(DxDropDownBoxComponent, { static: false }) iddDropDown!: DxDropDownBoxComponent;
  isDataLoaded: boolean = false;
  employees!: SelectOption[];
  qualificationTargetTypeOptions!: DxSelectBoxTypes.Properties;
  segmentOptions!: DxSelectBoxTypes.Properties;
  locations: OrganisationUnitModel[] = [];

  iddTargetAmount: { hours: number; minutes: number } = {
    hours: 0,
    minutes: 0,
  };

  tenant!: TenantModel;
  tenantUpdateModel: TenantUpdateModel = {
    qualificationTargetIddTime: 0,
    qualificationTargetType: QualificationTargetTypeModel.ByEmployee,
    iddResponsiblePersonId: null,
    createEmployeeAccounts: false,
    createManagerAccounts: false,
    createTrainerAccounts: false,
    createSuperAdminAccounts: false,
    createBrokerAccounts: false,
    sendTrainingProgressMail: false,
    sendTrainingProgressMailToBrokers: false,
    enableExternalCertificateApproval: false,
    certificateFontFamily: null,
    certificateFontSize: null,
    domains: [],
    loginBackgroundFile: null,
    loginLogoFile: null,
    defaultLocationId: null,
    segment: null,
    registrationFieldConfigs: [],
    isIddEscalationEnabled: false,
    iddEscalationThresholds: []
  };

  subscriptionUpdateModel: TenantSubscriptionUpdateModel = {
    name: '',
    description: '',
    publishToSubscribers: false,
    isPrivatePublishing: false,
    file: null
  };

  subscription: TenantSubscriptionModel | null = null;

  missingEmployeesData: UnregisteredRoleModel | null = null;
  missingManagersData: UnregisteredRoleModel | null = null;
  missingTrainersData: UnregisteredRoleModel | null = null;
  missingSuperAdminsData: UnregisteredRoleModel | null = null;
  missingBrokersData: UnregisteredRoleModel | null = null;

  selectedTab: number = SettingTabsModel.GeneralSettings;
  SettingTabsModel = SettingTabsModel;

  hasSubscription: boolean = false;
  subscriptionFileUploaded: File | null = null;
  subscriptionImage: string | null = null;

  loginBackgroundFileUploaded: File | null = null;
  loginBackgroundImage: string | null = null;
  
  loginLogoFileUploaded: File | null = null;
  loginLogoImage: string | null = null;

  showActivatePublishingModeModal: boolean = false;
  showDeactivatePublishingModeModal: boolean = false;
  showPreviewLoginModal: boolean = false;
  showPublishingModeRequiredModal: boolean = false;

  channels: TenantChannelModel[] = [];
  isIndividualBrokerTenant: boolean = false;
  
  registrationFields: RegistrationFieldConfigModel[] = [];
  roles: RoleModel[] = [];
  isTopLevelSuperAdmin: boolean = false;

  readonly fontFamilyOptions = {
    items: FONT_FAMILIES,
    searchEnabled: true
  };

  readonly fontSizeOptions = {
    items: FONT_SIZES
  };

  tabs: any[] = [
    {
      id: SettingTabsModel.GeneralSettings,
      text: this.translateService.instant('COMMON.FIELDS.GENERAL-SETTINGS'),
    },
    {
      id: SettingTabsModel.LicenseManagement,
      text: this.translateService.instant('COMMON.FIELDS.LICENSE-MANAGEMENT'),
    },
    {
      id: SettingTabsModel.Domains,
      text: this.translateService.instant('COMMON.FIELDS.DOMAINS'),
    },
    {
      id: SettingTabsModel.Subscription,
      text: this.translateService.instant('COMMON.FIELDS.PUBLISHING-INFORMATION'),
    },
    {
      id: SettingTabsModel.Login,
      text: this.translateService.instant('COMMON.FIELDS.LOGIN'),
    },
  ];


  readonly minutesInHour = 60;
  isCreateMissingUsersRunning: boolean = false;

  private readonly tabMap: Record<string, SettingTabsModel> = {
    qualification: SettingTabsModel.GeneralSettings,
    license: SettingTabsModel.LicenseManagement,
    domains: SettingTabsModel.Domains,
    subscription: SettingTabsModel.Subscription,
    login: SettingTabsModel.Login,
  };

  get isTenantPublishedToSubscribers(): boolean {
    return this.subscriptionUpdateModel.publishToSubscribers;
  }

  public get showSendTrainingProgressMailToBrokers(): boolean {
    return this.tenantUpdateModel?.sendTrainingProgressMail
      && this.tenant.type !== TenantTypeModel.BrokerPool;
  }

  constructor(
    private loadingService: LoadingService,
    private settingsService: GeneralSettingsService,
    private personService: PersonService,
    private roleService: RoleService,
    private userService: UserService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private tenantSubscriptionService: TenantSubscriptionService,
    private fileUtilService: FileUtilService,
    private route: ActivatedRoute,
    private router: Router,
    private registrationFieldConfigService: RegistrationFieldConfigService,
    private authorizationService: AuthorizationService,
    private clipboard: Clipboard,
    private organisationUnitService: OrganisationUnitService,
  ) {
    this.loadData();
  }

  private loadData() {
    this.isDataLoaded = false;

    const settingsData = this.loadingService
      .load(
        forkJoin({
          settings: this.settingsService.getTenant(),
          unregisteredPersons: this.settingsService.getUnregisteredPersons(),
          employees: this.personService.getPersonsWithoutBrokers(),
          roles: this.roleService.getAllRoles(),
          locations: this.organisationUnitService.getAllOrganisationUnits(),
          domains: this.settingsService.getTenantDomains(),
          subscription: this.tenantSubscriptionService.getCurrentTenantSubscription(),
          registrationFields: this.registrationFieldConfigService.getAllRegistrationFieldConfigs()
        })
      )
      .pipe(shareReplay(1));

    settingsData.subscribe(({ 
      settings, unregisteredPersons, employees, roles, 
      domains, subscription, registrationFields, locations
    }) => {
      this.registrationFields = registrationFields;
      this.roles = roles;
      this.locations = locations;
      
      this.employees = employees.map((employee) => ({
        id: employee.id,
        name: `${employee.firstName} ${employee.lastName}`,
      }));

      this.missingEmployeesData = null;
      this.missingManagersData = null;
      this.missingTrainersData = null;
      this.missingSuperAdminsData = null;
      this.missingBrokersData = null;

      unregisteredPersons.forEach((personType) => {
        const role = roles.find((role) => role.id == personType.roleId);

        if (role!.name === 'Manager') {
          this.missingManagersData = personType;
        } else if (role!.name === 'Employee') {
          this.missingEmployeesData = personType;
        } else if (role!.name === 'Trainer') {
          this.missingTrainersData = personType;
        } else if (role!.name === 'SuperAdmin') {
          this.missingSuperAdminsData = personType;
        } else if (role!.name === 'Broker') {
          this.missingBrokersData = personType;
        }
      });
      if(subscription)
      {
        this.hasSubscription = true;
        this.subscription = subscription;
        this.patchSubscriptionForm(subscription);
      }

      this.tenant = settings;
      this.isIndividualBrokerTenant = settings.type === TenantTypeModel.Individual;
      
      this.authorizationService
        .getCurrentPerson()
        .pipe(first())
        .subscribe((person) => {
          this.isTopLevelSuperAdmin = 
            person.person.role.name == ROLE_NAMES.SuperAdmin &&
            person.person.location.topLevel
        });

      this.patchForm(settings, domains, registrationFields);

      this.setDropdownOptions();
      this.isDataLoaded = true;
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const tabKey = (params['tab'] || '').toLowerCase();
      this.selectedTab = this.tabMap[tabKey] ?? SettingTabsModel.GeneralSettings;
    });

    this.checkCreateMissingUsersStatus();

    interval(30 * 1000).subscribe(() => { 
      this.checkCreateMissingUsersStatus(); // every 30 seconds
    });
  }

  onSendTrainingProgressMailChanged(e: any): void {
    if (!e.value) {
      this.tenantUpdateModel.sendTrainingProgressMailToBrokers = false;
    }
  }

  checkCreateMissingUsersStatus() {
    this.userService.isCreateMissingUsersRunning()
    .subscribe(res => {
      const wasRunning = this.isCreateMissingUsersRunning;
      const isRunning = res.isRunning;

      if (wasRunning && !isRunning) {
        this.loadData();
      }

      this.isCreateMissingUsersRunning = isRunning;
    });
  }

  isBrokerRole(roleId: string): boolean {
    const role = this.roles.find((role) => role.id == roleId);
    if(!role) return false;

    return role.name === ROLE_NAMES.Broker;
  }
  
  registerMissingAccounts(roleId: string) {
    const isBrokerRole = this.isBrokerRole(roleId);

    if(!this.isTenantPublishedToSubscribers && isBrokerRole) {
      this.showPublishingModeRequiredModal = true;
      return;
    }
    
    this.loadingService
      .load(this.userService.registerMissingAccounts(roleId))
      .subscribe({
        next: () => {
          this.isCreateMissingUsersRunning = true;
          this.toastrService.info(
            this.translateService.instant('SETTINGS.CREATE-ACCOUNTS-STARTED')
          );
        },
        error: () => {
          this.isCreateMissingUsersRunning = false;
        }
      });
  }

  setDropdownOptions() {
    const defaultSelectOptions = {
      showClearButton: true,
      stylingMode: 'outlined',
      displayExpr: 'name',
      valueExpr: 'id',
      searchEnabled: true,
    } as DxSelectBoxTypes.Properties;

    this.qualificationTargetTypeOptions = {
      ...defaultSelectOptions,
      searchEnabled: false,
      dataSource: [
        {
          id: 0,
          name: this.translateService.instant(
            'COMMON.FIELDS.DEFINITION-TYPES.BY-EMPLOYEE'
          ),
        },
      ],
      placeholder: this.translateService.instant('COMMON.FIELDS.DEFINITION'),
    };

    this.segmentOptions = {
      ...defaultSelectOptions,
      searchEnabled: false,
      dataSource: [
        {
          id: MarketSegmentModel.HR,
          name: this.translateService.instant(
            'COMMON.FIELDS.MARKET-SEGMENT-TYPES.HR'
          ),
        },
        {
          id: MarketSegmentModel.Events,
          name: this.translateService.instant(
            'COMMON.FIELDS.MARKET-SEGMENT-TYPES.EVENTS'
          ),
        },
        // {
        //   id: MarketSegmentModel.Teacher,
        //   name: this.translateService.instant(
        //     'COMMON.FIELDS.MARKET-SEGMENT-TYPES.TEACHER'
        //   ),
        // },
      ],
      placeholder: this.translateService.instant('COMMON.FIELDS.MARKET-SEGMENT'),
    };
  }

  handleIddTargetTimePicker(value: { hours: number; minutes: number }) {
    this.iddTargetAmount.hours = value.hours;
    this.iddTargetAmount.minutes = value.minutes;
    this.tenantUpdateModel.qualificationTargetIddTime =
      this.iddTargetAmount.hours * this.minutesInHour + this.iddTargetAmount.minutes;
  }

  onIddResponsibleSelected(e: any) {
    if (e.node.key) {
      this.tenantUpdateModel.iddResponsiblePersonId = e.node.key;
    }
  }

  onDefaultLocationSelected(id: string | number | undefined): void {
    const location = this.locations.find(location => location.id === id);
    if (!location) {
      throw new Error('The selected default location is not available.');
    }
    this.tenantUpdateModel.defaultLocationId = location.id;
  }

  onFormSubmit(): void {
    const isFormValid = this.isFormValid();

    if (!isFormValid) {
      this.toastrService.error(
        this.translateService.instant('VALIDATIONS.VALUES-NOT-VALID')
      );
      return;
    }

    const backgroundFile$: Observable<RawFileModel | null> = this.loginBackgroundFileUploaded
      ? from(this.fileUtilService.convertFileToRawFileModel(this.loginBackgroundFileUploaded))
      : of(null);

    const logoFile$: Observable<RawFileModel | null> = this.loginLogoFileUploaded
      ? from(this.fileUtilService.convertFileToRawFileModel(this.loginLogoFileUploaded))
      : of(null);

    if(this.registrationFieldConfigsForm) {
      this.tenantUpdateModel.registrationFieldConfigs =
        this.registrationFieldConfigsForm.fields;
    }

    this.loadingService.load(
      forkJoin({
        backgroundFile: backgroundFile$,
        logoFile: logoFile$
      }).pipe(
        switchMap(({ backgroundFile, logoFile }) => {
          this.tenantUpdateModel.loginBackgroundFile = backgroundFile;
          this.tenantUpdateModel.loginLogoFile = logoFile;

          return this.settingsService.updateSettings(this.tenantUpdateModel);
        }),
        switchMap(tenant =>
          this.settingsService.getTenantDomains().pipe(
            map(domains => ({ tenant, domains }))
          )
        )
      )
    ).subscribe(({ tenant, domains }) => {
      if (tenant.segment !== this.tenant.segment
        || tenant.iddResponsiblePersonId !== this.tenant.iddResponsiblePersonId
      ) {
        location.reload();
      }

      this.toastrService.success('Settings successfully updated!');
      this.tenant = tenant;
      this.tenantUpdateModel.domains = domains;

      this.loginBackgroundFileUploaded = null;
      this.loginBackgroundImage = null;
      this.loginLogoFileUploaded = null;
      this.loginLogoImage = null;
    });
  }

  isFormValid(): boolean {
    const segmentValid = this.segmentForm
      ? this.segmentForm.instance.validate().isValid
      : true;

    const qualificationValid = this.qualificationForm
      ? this.qualificationForm.instance.validate().isValid
      : true;

    let isCustomFieldsValid = true;
    const group = validationEngine.getGroupConfig('customFields');
    
    if (group) {
      const customFieldsResult = validationEngine.validateGroup('customFields');

      if (!customFieldsResult.isValid) {
        isCustomFieldsValid = false;
        this.scrollToFirstBrokenRule(customFieldsResult);
      }
    }

    const iddEscalationTimeValid =
      this.iddEscalationThresholdsComponent?.isIddEscalationTimeValid() ?? true;

    if (!iddEscalationTimeValid) {
      this.iddEscalationThresholdsComponent.scrollIntoView();
      return false;
    }

    if (
      !segmentValid || !qualificationValid || 
      !isCustomFieldsValid || !iddEscalationTimeValid
    ) {
      return false;
    }

    return true;
  }

  private scrollToFirstBrokenRule(result: any): void {
    if (!result?.brokenRules?.length) return;

    const firstBrokenRule = result.brokenRules[0] as any;
    const element = firstBrokenRule?.validator?.$element?.();

    element?.[0]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    element?.[0]?.focus();
  }

  patchForm(
    tenant: TenantModel, domains: string[], 
    registrationFields: RegistrationFieldConfigModel[]
  ) {
    this.tenantUpdateModel.qualificationTargetIddTime =
      tenant.qualificationTargetIddTime;
    this.tenantUpdateModel.qualificationTargetType =
      tenant.qualificationTargetType;
    this.tenantUpdateModel.iddResponsiblePersonId = tenant.iddResponsiblePersonId;
    this.tenantUpdateModel.createEmployeeAccounts = tenant.createEmployeeAccounts;
    this.tenantUpdateModel.createManagerAccounts = tenant.createManagerAccounts;
    this.tenantUpdateModel.createTrainerAccounts = tenant.createTrainerAccounts;
    this.tenantUpdateModel.createSuperAdminAccounts = tenant.createSuperAdminAccounts;
    this.tenantUpdateModel.createBrokerAccounts = tenant.createBrokerAccounts;
    this.tenantUpdateModel.sendTrainingProgressMail =
      tenant.sendTrainingProgressMail;
    this.tenantUpdateModel.sendTrainingProgressMailToBrokers =
      tenant.sendTrainingProgressMailToBrokers;
    this.tenantUpdateModel.enableExternalCertificateApproval =
      tenant.enableExternalCertificateApproval;
    this.tenantUpdateModel.certificateFontFamily = tenant.certificateFontFamily;
    this.tenantUpdateModel.certificateFontSize = tenant.certificateFontSize;
    this.tenantUpdateModel.segment = tenant.segment;
    this.tenantUpdateModel.defaultLocationId = tenant.defaultLocationId;
    this.iddTargetAmount.hours = TimeService.getHoursFromAbsoluteMinutes(
      tenant.qualificationTargetIddTime || 0
    );
    this.iddTargetAmount.minutes = TimeService.getMinutesFromAbsoluteMinutes(
      tenant.qualificationTargetIddTime || 0
    );
    this.tenantUpdateModel.domains = domains;
    this.tenantUpdateModel.registrationFieldConfigs = registrationFields;
    this.tenantUpdateModel.isIddEscalationEnabled = tenant.isIddEscalationEnabled;
    this.tenantUpdateModel.iddEscalationThresholds =
      tenant.iddEscalationThresholds ?? [];
  }

  patchSubscriptionForm(subscription: TenantSubscriptionModel) {
    this.subscriptionUpdateModel = {
      name: subscription.name,
      description: subscription.description,
      publishToSubscribers: subscription.publishToSubscribers,
      isPrivatePublishing: subscription.isPrivatePublishing,
      file: null
    };
  }

  onTabChange(e: DxTabsTypes.ItemClickEvent) {
    this.selectedTab = e.itemData.id;

    const tabName = Object.keys(this.tabMap).find(
      key => this.tabMap[key] === this.selectedTab
    );

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabName },
      queryParamsHandling: 'merge',
    });
  }

  onIddEscalationEnabledChanged(e: any): void {
    if (!e.value) {
      this.tenantUpdateModel.iddEscalationThresholds = [];
    }
  }

  onSubscriptionImageUploaded(files: any) {
    if(!files || files.length == 0) return;

    const file = files[0];
    this.subscriptionFileUploaded = file;

    const imageBlob = new Blob([file], { type: file.type });
    this.subscriptionImage = URL.createObjectURL(imageBlob);
  }

  onLoginBackgroundImageUploaded(files: any) {
    if(!files || files.length == 0) return;

    const file = files[0];
    this.loginBackgroundFileUploaded = file;

    const imageBlob = new Blob([file], { type: file.type });
    this.loginBackgroundImage = URL.createObjectURL(imageBlob);
  }
  
  onLoginLogoImageUploaded(files: any) {
    if(!files || files.length == 0) return;

    const file = files[0];
    this.loginLogoFileUploaded = file;

    const imageBlob = new Blob([file], { type: file.type });
    this.loginLogoImage = URL.createObjectURL(imageBlob);
  }
  
  onUpdateSubscription() {
    const isSubscriptionFormValid =
      this.subscriptionForm.instance.validate().isValid;

    if(!isSubscriptionFormValid){
      return;
    }

    const file$: Observable<RawFileModel | null> = this.subscriptionFileUploaded
      ? from(this.fileUtilService.convertFileToRawFileModel(this.subscriptionFileUploaded))
      : of(null);

    this.loadingService
      .load(from(file$)
        .pipe(
          switchMap((file: RawFileModel | null) => {
            this.subscriptionUpdateModel.file = file;
            return this.tenantSubscriptionService.updateTenantSubscription(this.subscriptionUpdateModel);
          })
        )
      )
      .subscribe((subscription) => {
        this.subscription = subscription;
        this.patchSubscriptionForm(subscription);

        this.subscriptionFileUploaded = null;
        this.subscriptionImage = null;

        this.toastrService.success(
          this.translateService.instant('TENANT-SUBSCRIPTION.SUBSCRIPTION-UPDATED')
        );
      });
  }

  onCreateSubscription() {
    const isSubscriptionFormValid =
      this.subscriptionForm.instance.validate().isValid;

    if(!isSubscriptionFormValid){
      return;
    }

    if(!this.subscriptionFileUploaded) {
      this.toastrService.error(
        this.translateService.instant('VALIDATIONS.FILE-REQUIRED')
      );
      return;
    }

    const file$: Observable<RawFileModel | null> = from(
      this.fileUtilService.convertFileToRawFileModel(this.subscriptionFileUploaded)
    );

    this.loadingService
      .load(from(file$)
        .pipe(
          switchMap((file: RawFileModel | null) => {
            this.subscriptionUpdateModel.file = file;
            return this.tenantSubscriptionService.createTenantSubscription(this.subscriptionUpdateModel);
          })
        )
      )
      .subscribe((subscription) => {
        this.subscription = subscription;
        this.patchSubscriptionForm(subscription);

        this.hasSubscription = true;
        this.subscriptionFileUploaded = null;
        this.subscriptionImage = null;

        this.toastrService.success(
          this.translateService.instant('TENANT-SUBSCRIPTION.SUBSCRIPTION-CREATED')
        );
      });
  }

  deactivatePublishingMode() {
    this.showDeactivatePublishingModeModal = true;
  }

  onActivatedPublishingMode() {
    if(!this.subscription) return;

    this.subscription.publishToSubscribers = true;
    this.onUpdateSubscription();
  }

  onDeactivatedPublishingMode() {
    if(!this.subscription) return;

    this.subscription.publishToSubscribers = false;
    this.onUpdateSubscription();
  }

  activatePublishingMode() {
    this.showActivatePublishingModeModal = true;
  }

  onCopySubscriptionLink(): void {
    if(!this.subscription) return;

    const url = new URL(
      window.location.origin + '/subscriptions'
    );

    url.searchParams.set('tenantSubscriptionId', this.subscription.id);

    if (this.clipboard.copy(url.toString())) {
      this.toastrService.success(
        this.translateService.instant("COPY-LINK.COPY-SUCCESS")
      );
    } else {
      this.toastrService.warning(
        this.translateService.instant("COPY-LINK.COPY-FAILURE")
      );
    }
  }

  openPreviewLogin(): void {
    this.showPreviewLoginModal = true;
  }
}
